module.exports = __webpack_public_path__ + "static/img/frames-slide.a9caeba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frames-slide.webp
// module id = tdBd
// module chunks = 0